
import { AddFeedback } from 'src/content/Feedback/interfaces/addFeedback';
import { get, post, put, remove } from './mainApi';
import { generateId } from 'src/utils/traceIdGenerations';

const feedbackServiceBaseURL =
  process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;



export const getAllCategories = async () => {
  const traceId = generateId(9);
  var response = get(`${feedbackServiceBaseURL}feedback/category?traceId=${traceId}`);
  return response;
};


export const getSendAndReceivedFeedback = async (isSender: boolean, pageSize: number, pageNo: number,body:any) => {
  const traceId = generateId(9);
  var response = post(`${feedbackServiceBaseURL}feedback/getfeedbacks?isSender=${isSender}&pageSize=${pageSize}&pageNo=${pageNo}`,body);
  return response;
};

export const getSendAndReceivedFeedbackSuperUser = async (pageSize: number, pageNo: number,categoryId:number[],body:any) => {
  const traceId = generateId(9);
  var response = post(`${feedbackServiceBaseURL}feedback/getfeedbacks?pageSize=${pageSize}&pageNo=${pageNo}&categoryId=${categoryId ? categoryId: ""}`,body);
  return response;
};

export const createFeedback = async (feedbackData: AddFeedback) => {
  const traceId = generateId(9);
  const response = await post(`${feedbackServiceBaseURL}feedback?traceId=${traceId}`,
    feedbackData
  );
  return response;
};


export const getSendReceive = async (isSender: boolean) => {
  var response = get(`${feedbackServiceBaseURL}feedback/users?isSender=${isSender}`);
  return response;
};

export const updateFeedback = async (feedbackData: AddFeedback) => {
  const traceId = generateId(9);
  const response = await put(`${feedbackServiceBaseURL}feedback?traceId=${traceId}`,
    feedbackData
  );
  return response;
};


export const getRmIds = async () => {
  var response = get(`${feedbackServiceBaseURL}employee/reporting-managers`);
  return response;
};

